module.exports = {
      id: "white-fb-usage",
      viewBox: "0 0 41 40",
      url: __webpack_public_path__ + "svg-sprite-dd330238154521d0397e6121ac041d84.svg#white-fb",
      toString: function () {
        return this.url;
      }
    }